import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

let appInsights = null;

if (connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString,
      enableAutoRouteTracking: true,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      correlationHeaderExcludedDomains: [
        '*.campusevolve.ai',
        '*.auth0.com',
        '*.us.auth0.com',
        '*.eu.auth0.com',
        '*.ciamlogin.com',
        '*.login.microsoftonline.com',
        '*.msauth.net',
        '*.msauthimages.net'
      ]
    }
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();
}

export default appInsights;